import * as React from 'react';

import ActionMessage from 'components/action-message/ActionMessage';
import SettingsMessage from 'components/settings-message/SettingsMessage';

import {
  isBrandSettingsPageInComplete,
  isBrandsFocusedOrganization,
  isInfluencerSettingsPageIncomplete,
  isInfluencersFocusedOrganization
} from 'utils/organization';
import { t } from 'utils/language';

import type { Organization, OrganizationSettings } from 'types';

type Props = {
  hasCampaigns: boolean,
  organization: Organization,
  organizationSettings: OrganizationSettings
};

class CampaignsMessages extends React.Component<Props> {
  renderBrandHeading(): React.ReactNode {
    const {
      hasCampaigns,
      organization,
      organizationSettings
    } = this.props;

    const hasProfile = organization.brandProfiles && organization.brandProfiles.length > 0;
    const settingsPageIncomplete = isBrandSettingsPageInComplete(organizationSettings);

    return (
      <React.Fragment>
        {
          settingsPageIncomplete && (
            <SettingsMessage
              organizationId={organizationSettings.id}
              organizationSettings={organizationSettings}
            />
          )
        }
        {
          !hasCampaigns && !hasProfile && (
            <div className="campaigns-heading__empty-message">
              {t('campaigns_list_empty_no_profile')}
            </div>
          )
        }
      </React.Fragment>
    );
  }

  renderInfluencerHeading(): React.ReactNode {
    const {
      hasCampaigns,
      organization,
      organizationSettings
    } = this.props;

    const hasProfile = organization.influencerProfiles && organization.influencerProfiles.length > 0;
    const settingsPageIncomplete = isInfluencerSettingsPageIncomplete(organizationSettings);

    return (
      <React.Fragment>
        {
          settingsPageIncomplete && (
            <SettingsMessage
              organizationId={organizationSettings.id}
              organizationSettings={organizationSettings}
              showButton={settingsPageIncomplete}
              isSticky
            />
          )
        }
        {
          !hasCampaigns && (
            <ActionMessage
              message={t(hasProfile ? 'campaigns_list_empty_for_influencer' : 'campaigns_list_empty_no_profile')}
            />
          )
        }
      </React.Fragment>
    );
  }

  render(): React.ReactNode {
    const { organization } = this.props;

    if (isBrandsFocusedOrganization(organization)) {
      return this.renderBrandHeading();
    }

    if (isInfluencersFocusedOrganization(organization)) {
      return this.renderInfluencerHeading();
    }

    return null;
  }
}

export default CampaignsMessages;
